import * as Yup from 'yup';
import { t } from '@lingui/macro';

export const newsletterFormSchema = Yup.object({
  email: Yup.string()
    .email(t`Enter valid email`)
    .required(t`Required`),
});
